module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-Blue-Monster-Roll-On-The_Ground-Web-640.9b01ad60.jpg";